import { render } from "./footer.vue?vue&type=template&id=6175f5d3"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=6175f5d3&lang=css"

import exportComponent from "/Users/kellyluo/Work/projects/icheer-web-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__